import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var AlignHorizontalRight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"
  }));
});
AlignHorizontalRight.displayName = 'AlignHorizontalRight';
export var AlignHorizontalRightDimensions = {
  height: 24,
  width: 24
};